import * as React from 'react';
import {
    Create,
    TextInput,
    SimpleForm,
    BooleanInput,
    required,
    useTranslate,
} from 'react-admin';
import { RichTextInput } from '../../components/RichTextInput';
import { Typography } from '@mui/material';

const req = [required()];

const EntityCreate = () => {
    const translate = useTranslate();

    return (
        <>
            {/* @ts-ignore */}
            <Create>
                <SimpleForm sx={{ maxWidth: { xl: '80%' } }}>
                    <TextInput
                        source="title"
                        validate={req}
                        isRequired
                        fullWidth
                    />
                    <TextInput
                        source="slug"
                        validate={req}
                        isRequired
                        fullWidth
                    />
                    <BooleanInput source="active" fullWidth />
                    <TextInput
                        source="annotation"
                        fullWidth
                        multiline
                        maxRows={'10'}
                    />
                    <RichTextInput source="content" fullWidth />
                    <RichTextInput source="additional_content_1" fullWidth />
                    <RichTextInput source="additional_content_2" fullWidth />
                    <Typography variant="h6" gutterBottom>
                        {translate('resources.pages.fieldGroups.seo')}
                    </Typography>
                    <TextInput source="seo_h1" fullWidth />
                    <TextInput
                        source="seo_description"
                        fullWidth
                        multiline
                        maxRows={'10'}
                    />
                    <BooleanInput source="seo_no_index" fullWidth />
                    <TextInput source="seo_canonical" fullWidth />
                </SimpleForm>
            </Create>
        </>
    );
};

export default EntityCreate;
